import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { ConfirmationService, MessageService } from 'primeng/api'
import { concatMap, from, map, mergeMap, of, tap, toArray } from 'rxjs'
import {
  Category,
  DataPageOfImage,
  ImageModels,
  UiPreferences,
} from '../../../../../api/models'
import {
  AppSettingService,
  DocumentService,
  ImageService,
} from '../../../../../api/services'
import { Customsort } from '../../../../directives/customsort'
import { ThumbnailCreationService } from '../../../../services/thumbnail-creation.service'
import { CareFinitySession } from '../../../../services/CareFinitySession'
import { SelectedPatientService } from '../../patient-list/patient-service'
import { getLabelAndCount } from '../../../../services/docUtils'

@Component({
  selector: 'app-image-thumbnail',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
})
export class ListComponent implements OnInit {
  Item = 'Image List'
  distinctImageList: Array<Category> = []
  distinctImageresult: any = []
  arrimagedetails: any = { data: [] }
  User: any
  imageHeader: string = ''
  rows: number
  private cols: any[]
  gridHeader: string = ''
  displaypopup: boolean = false
  pdfSrc: any
  selectedCategoryId = ''
    tempResult: DataPageOfImage;

    preferences: UiPreferences = {};
  items = [
    { label: 'Home', icon: 'pi pi-fw pi-home' },
    { label: 'Calendar', icon: 'pi pi-fw pi-calendar' },
    { label: 'Edit', icon: 'pi pi-fw pi-pencil' },
    { label: 'Documentation', icon: 'pi pi-fw pi-file' },
    { label: 'Settings', icon: 'pi pi-fw pi-cog' },
  ]
  activeItem
  pageNumber: number
  categoryId: any
  loading: boolean
    showCategoryView = false
    resetState = true;
    setPrintFlag: boolean = false;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private thumbnailCreationService: ThumbnailCreationService,
    private docservice: DocumentService,
    private fb: UntypedFormBuilder,
    private imageservice: ImageService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private selectedPatientService: SelectedPatientService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private cstsort: Customsort,
    protected sanitizer: DomSanitizer,
    private appSettingsService: AppSettingService,
  ) {}

  ngOnInit() {
    this.cols = [{ field: 'displayDescription', header: 'Category Name' }]

      this.LoaddistinctImageList();

     

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.images || 'Image List';
      }


     
  }
  LoaddistinctImageList(): void {
    this.imageservice
      .imageGetcategorylistbypatient({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
      .subscribe((result) => {
        this.distinctImageList = result
        this.showCategoryView = true

        if (result.length > 0) {
          this.activeItem = result[0]
          this.setItem(result[0])
          //  this.loadimageList(1, "", result[0].categoryId);
          //  this.gridHeader = result[0].categoryName;
        }
      })
  }



    loadimageList(
    pageNumber: number,
    sortbydirection: string,
    categoryId: string,
  ) {
    this.pageNumber = pageNumber
    this.imageservice
      .imageList({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        category: categoryId,
      })
      .pipe(
          tap((result) => {
              this.resetState = true;

            this.tempResult = result

        }),
        map((list) => list.data),
        concatMap((data) => from(data)),
        concatMap((i) => {
          return this.getdocumnetdetails(i).pipe(
            map((p) => {
              return { ...i, ...p }
            }),
          )
        }),

        concatMap((i) => {
          if (i.documentBlob.size == 0) return of({ ...i })
          return this.thumbnailCreationService
            .getPdfThumbnail(i.documentBlob)
            .pipe(
              tap((i) => console.log(i)),

              map((t) => ({ ...i, thumbnail: t })),
            )
        }),
        toArray(),
      )
      .subscribe((result) => {
        this.arrimagedetails = {
          ...this.tempResult,
          data: [...this.arrimagedetails?.data, ...result],
        }

        console.log('result is', result)
        this.rows = this.arrimagedetails.pageSize
        this.changeDetectorRef.detectChanges()
        this.loading = false
      })
  }
  setItem(category) {
      console.log('active ite change', category)
      this.resetState = false;
    /// console.log(this.distinctImageresult);
    this.selectedCategoryId = category.categoryId
    this.gridHeader = category.categoryName
      this.loadimageList(1, '', category.categoryId)

    this.arrimagedetails = { data: [] }
  }

  initData(i) {
    console.log(i)
  }

    showDocument(file) {
        console.log(CareFinitySession?.practiceSettings?.enablePatientDemographicPrint , CareFinitySession?.user?.roles?.patientRecordsPrint)
    if (file?.documentBlob?.size <= 0) {
      this.messageService.add({
        key: 'alertToast',
        severity: 'error',
        summary: 'ERROR',
        detail: 'Image missing, Please Contact Technical Support',
      })
      return
    }

    if (file.flexPaper) {
      this.router.navigate(['show-pdf'], {
        relativeTo: this.activatedRoute,
        state: {
          pdf: file.documentBlob,
            showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
            enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads

        },
      })
    } else {
      let dataType = file.documentBlob.type
      if (file.documentBlob.size == 0) {
        this.messageService.add({
          key: 'alertToast',
          severity: 'error',
          summary: 'ERROR',
          detail: 'Image missing, Please Contact Technical Support',
        })

        return
      }

      let binaryData = []

      binaryData.push(file.documentBlob)
      let downloadLink = document.createElement('a')
      downloadLink.href = window.URL.createObjectURL(
        new Blob(binaryData, { type: dataType }),
      )

      downloadLink.target = '_blank'
      downloadLink.setAttribute('inline', 'arshid')
      document.body.appendChild(downloadLink)
      downloadLink.click()
    }
  }
  loadMore() {
    if (!this.loading)
      this.loadimageList(this.pageNumber + 1, '', this.selectedCategoryId)
    this.loading = true
  }
  getdocumnetdetails(obj) {
    this.User = JSON.parse(localStorage.getItem('currentUser'))

    return this.imageservice
      .imageDetail({
        DocumentType: obj.documentType,
        InDataBase: obj.inDataBase,
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),

        Id: obj.documentID,
        FileType: obj.fileType,
        UserId: CareFinitySession.user.userID.toString(),
      })
      .pipe(
        map((imgDetails) => ({ ...obj, ...imgDetails })),

        mergeMap((docementDetails: ImageModels) => {
          if (docementDetails.errorMessage) {
            return of({ ...docementDetails, documentBlob: new Blob() })
          }

          return this.docservice
            .documentGetDocuments({
              fn: docementDetails.selectedPDF,
              PatientName: sessionStorage.getItem('ptName'),
            })
            .pipe(mergeMap((i) => of({ ...docementDetails, documentBlob: i })))
        }),
      )
  }
  back() {
    window.history.back()
    }


    getLabelAndCount(item) {

        return getLabelAndCount(item, this.distinctImageList);
    }
}

/*                .subscribe(file => {
 
 
          if (docementDetails.flexPaper) {
              this.router.navigate(["Patient", "show-pdf"], {
                  state: {
 
                      pdf: file
                  }
              })
          }
          else {
 
              let dataType = file.type;
              let binaryData = [];
              binaryData.push(file);
              let downloadLink = document.createElement('a');
         downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
 
              this.href = downloadLink.href;
              this.visible = true**/ /*//*
downloadLink.target = "_blank";
downloadLink.setAttribute('inline', "arshid");
document.body.appendChild(downloadLink);
downloadLink.click();

}



})
*/
//console.log()
